import { render, staticRenderFns } from "./bettwasche.vue?vue&type=template&id=a6ad4748&"
import script from "./bettwasche.vue?vue&type=script&lang=js&"
export * from "./bettwasche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6ad4748')) {
      api.createRecord('a6ad4748', component.options)
    } else {
      api.reload('a6ad4748', component.options)
    }
    module.hot.accept("./bettwasche.vue?vue&type=template&id=a6ad4748&", function () {
      api.rerender('a6ad4748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gFGWRpmJbebf/JS/comp/bettwasche.vue"
export default component.exports